/* eslint-disable camelcase */
import { createSelector } from 'reselect';
import translations from 'translations';
import formatNumber from 'lib/format-number';
import configSelector from './config';

export default createSelector(
  (state) => state.count.payload,
  (_, key) => key,
  configSelector,
  (payload, key, { languageCode }) => {
    let percent = 0;
    const card = payload[key];

    if (!card || !card.data) return { percent, value: null };

    const {
      data: {
        aggregations: { current_period, previous_period },
      },
      query,
    } = card;

    const currentQuantity = current_period.total_quantity.value;
    const previousQuantity = previous_period.total_quantity.value;

    percent = 100;

    if (previousQuantity !== 0) {
      percent = Math.round(((currentQuantity - previousQuantity) / previousQuantity) * 100);
    }

    if (previousQuantity === 0 && currentQuantity === 0) percent = 0;

    return {
      percent,
      value: `${formatNumber(languageCode, currentQuantity)} ${query.match(/usage_data/) ? translations[languageCode].users : translations[languageCode].qty}`,
      previousValue: `${formatNumber(languageCode, previousQuantity)} ${query.match(/usage_data/) ? translations[languageCode].users : translations[languageCode].qty}`,
    };
  },
);
